import {loop} from '../../utils/styles/animation';
import {FiLoader} from 'react-icons/fi';
import styled from 'styled-components';

interface ItemProps {
  readonly height?: string;
  readonly width?: string;
}

export const LoaderContainer = styled.span<ItemProps>`
  justify-content: center;
  align-items: center;
  display: flex;

  width: ${props => props.width};
  height: ${props => props.height};
`;

export const Loader = styled(FiLoader)<ItemProps>`
  color: ${props => props.color};
  font-size: 30px;
  ${loop({time: '1.5s'})}/* transform: rotate(334.37deg, 301, 301); */
`;
